import { useTranslation } from 'react-i18next';
import { Widget } from '@asset-metrix/portal-ui';
import { Stack, Text } from '@mantine/core';

import {
  DataSourceConfiguration,
  InvestmentComplianceLimitDataLevel,
  LimitMode,
  LimitParameter,
} from './createInvestmentLimitModel';
import { DataSourceSelection } from './DataSourceSelection';
import { LimitExpressionFields } from './LimitExpressionFields';

import styles from './createInvestmentLimitModal.module.scss';

export type DenominatorStepProps = {
  contentId: string;
  dataLevels: InvestmentComplianceLimitDataLevel[];
  denominator: DataSourceConfiguration;
  limitMode: LimitMode;
  onDenominatorChange: (update: Partial<DataSourceConfiguration>) => void;
  onParameterChange: (update: Partial<LimitParameter>) => void;
  parameter: LimitParameter;
};

export function DenominatorStep({
  contentId,
  dataLevels,
  denominator,
  limitMode,
  onDenominatorChange,
  onParameterChange,
  parameter,
}: DenominatorStepProps) {
  const { t } = useTranslation();

  return (
    <Stack className={styles['modal-step']}>
      <Widget title={t('app.investmentLimit.widgets.denominator')}>
        <div className={styles['modal-card-content']}>
          <Text className={styles['field-hint']}>
            {t('app.investmentLimit.preview.denominatorIntro')}
          </Text>
          <DataSourceSelection
            contentId={contentId}
            dataLevels={dataLevels}
            onChange={onDenominatorChange}
            source={denominator}
          />
        </div>
      </Widget>
      <Widget title={t('app.investmentLimit.widgets.evaluation')}>
        <div className={styles['modal-card-content']}>
          <LimitExpressionFields
            limitMode={limitMode}
            onChange={onParameterChange}
            parameter={parameter}
          />
        </div>
      </Widget>
    </Stack>
  );
}
